import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// Replace this with your own config details
export const fbConfig = {
  apiKey: "AIzaSyDTSHpsuT27rsxC--lEgoa9BZZs1ECCDZg",
  authDomain: "fittok-4619a.firebaseapp.com",
  databaseURL: "https://fittok-4619a.firebaseio.com",
  projectId: "fittok-4619a",
  storageBucket: "fittok-4619a.appspot.com",
  messagingSenderId: "83137786187",
  appId: "1:83137786187:web:0b6b99bebdbdf902bfb8ce",
};

firebase.initializeApp(fbConfig);
firebase.firestore().settings({});

export default firebase;
